import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled from 'styled-components';
import { get } from '../../styles/constant';
const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  line-height: ", ";\n  font-size: ", ";\n"])), get('lineHeights.20'), get('fontSizes.14'));
const Title = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), get('colors.primary.blue.600'));
const Item = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  &:last-child {\n    .seperator {\n      display: none;\n    }\n    .isNotShortened {\n      cursor: default;\n    }\n    .title {\n      color: ", ";\n    }\n  }\n"])), get('colors.functional.grey.600'));
const Seperator = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0 ", ";\n"])), get('space.4'));
const Components = {
  Wrapper,
  Seperator,
  Item,
  Title
};
export { Components };